// Handles tab switching logic when editing cropper

const LIBRARY_FILE_IDENTIFIER = 'logo--library-logo-upload';
const DIRECT_UPLOAD_IDENTIFIER = 'logo--direct-logo-upload';
const SELECTOR_BY_CONTROLLER = (identifier) => `[data-controller="${identifier}"]`;
const SLIDE_FIRST_SELECTOR = '.media__slide-first';
const SLIDE_SECOND_SELECTOR = '.media__slide-second';
const SLIDE_ACTIVE_CLASS = 'media__slide--active';

function getController(identifier) {
  const element = document.querySelector(SELECTOR_BY_CONTROLLER(identifier));
  return element ? window.Stimulus.getControllerForElementAndIdentifier(element, identifier) : null;
}

function setSlideState(container, firstActive) {
  if (!container) return;
  const first = container.querySelector(SLIDE_FIRST_SELECTOR);
  const second = container.querySelector(SLIDE_SECOND_SELECTOR);
  if (!first || !second) return;
  first.classList.toggle(SLIDE_ACTIVE_CLASS, firstActive);
  second.classList.toggle(SLIDE_ACTIVE_CLASS, !firstActive);
}

export class LogoUploadTabManager {
  static switchToTab(activeTab, options = {}) {
    const {
      largerImageUrl,
      cropperDetails,
      originalImageName,
      zoom,
      onControllerReady
    } = options;

    let logoController = null;

    switch (activeTab) {
      case 'media_library': {
        logoController = getController(LIBRARY_FILE_IDENTIFIER);

        // Reset direct upload slide to first slide
        const directUploadLogoTab = document.querySelector(SELECTOR_BY_CONTROLLER(DIRECT_UPLOAD_IDENTIFIER));
        setSlideState(directUploadLogoTab, true);
        break;
      }
      case 'upload': {
        logoController = getController(DIRECT_UPLOAD_IDENTIFIER);

        // Reset media library slide to first slide
        const libraryFileLogoTab = document.querySelector(SELECTOR_BY_CONTROLLER(LIBRARY_FILE_IDENTIFIER));
        setSlideState(libraryFileLogoTab, true);
        break;
      }
      default:
        break;
    }

    this.activateTabContent(activeTab);

    if (cropperDetails && activeTab) {
      this.configureZoomSlider(activeTab, cropperDetails);
    }

    if (logoController && onControllerReady) {
      onControllerReady(logoController, {
        largerImageUrl,
        cropperDetails,
        originalImageName,
        zoom
      });
    }

    return logoController;
  }

  static activateTabContent(activeTab) {
    document.querySelectorAll('.tabbed .tabbed__trigger.active').forEach(tab => {
      tab.classList.remove('active');
    });

    const tabToActivate = document.querySelector(`.tabbed .tabbed__trigger[data-for-tab="${activeTab}"]`);
    if (tabToActivate) {
      tabToActivate.classList.add('active');
    }

    document.querySelectorAll('.tabs-content.media .content.active').forEach(tab => {
      tab.classList.remove('active');
      tab.setAttribute('hidden', '');
    });

    const tabContentToActivate = document.querySelector(`.tabs-content.media .content[data-tab-name="${activeTab}"]`);
    if (tabContentToActivate) {
      tabContentToActivate.classList.add('active');
      tabContentToActivate.removeAttribute('hidden');
    }
  }

  static configureZoomSlider(activeTab, cropperDetails) {
    const zoomSlider = document.querySelector(`#${activeTab} .media__cropper-zoom-slider`);
    if (zoomSlider && cropperDetails.sliderValue !== undefined) {
      zoomSlider.value = cropperDetails.sliderValue;
      const sliderColorPercentage = (zoomSlider.value - zoomSlider.min) / (zoomSlider.max - zoomSlider.min) * 100;
      zoomSlider.style.setProperty('--value', `${sliderColorPercentage}%`);
    }
  }

  static updateFileName(originalImageName) {
    const fileNameTarget = document.querySelector(`span[data-${LIBRARY_FILE_IDENTIFIER}-target="title"]`);
    if (fileNameTarget) {
      fileNameTarget.textContent = originalImageName;
    }
  }

  static openCropper(logoController, options) {
    const { largerImageUrl, cropperDetails, originalImageName, zoom } = options;

    if (logoController && logoController.openCropper) {
      logoController.openCropper(
        new Event('openCropper'),
        largerImageUrl,
        cropperDetails,
        originalImageName,
        zoom
      );
    }
  }
}
